import React from 'react';
import MapComponent from './MapComponent';

type InteractiveLocationMapProps = {
  locationName: string;
  description: string;
};

const InteractiveLocationMap: React.FC<InteractiveLocationMapProps> = ({ 
  locationName,
  description
}) => {
  return (
    <div className="py-6 animate-fade-in">
      <h2 className="text-xl md:text-2xl font-semibold mb-4">Où se situe le logement</h2>
      <h3 className="text-lg font-medium mb-2">{locationName}</h3>
      <p className="text-muted-foreground mb-6">{description}</p>
      
      <MapComponent locationName={locationName} />
    </div>
  );
};

export default InteractiveLocationMap;